export const HONEYBOOK_URL = "https://enchantingescapes.hbportal.co/public/6801b8bd8394b1002d88ccd7";
export const INSTAGRAM_URL = "https://www.instagram.com/enchanting_escapes_llc";
export const INSTAGRAM_HANDLE = "@enchanting_escapes_llc";
export const GOOGLE_BUSINESS_URL = "https://maps.app.goo.gl/8jSFgUMUiah2Dnra8";
export const TIKTOK_URL = "https://www.tiktok.com/@enchanting.escapes";
export const TIKTOK_HANDLE = "@enchanting.escapes";
export const PINTEREST_URL = "https://www.pinterest.com/enchantingescapesdfw";

export const MEDIA = {
    heroVideo: "/media/hero.mp4",
    reel: "/media/reel.mp4",
    clip1: "/media/clip1.mp4",
    clip2: "/media/clip2.mp4",
    clip3: "/media/clip3.mp4",
    clip4: "/media/clip4.mp4",
    fountain: "/media/fountain.png",
    tent: "/media/tent.jpeg",
    logo: "/media/logo.webp",
    monogram: "/media/monogram.png",
};

export const SERVICE_AREA = [
    "McKinney",
    "Dallas",
    "Frisco",
    "Plano",
    "Allen",
    "Prosper",
    "Celina",
    "The Colony",
    "Richardson",
    "Highland Park",
    "Southlake",
    "Fort Worth",
];

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1772724317675-5a1afcefea9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBwaWNuaWMlMjBzZXR1cCUyMHJvbWFudGljJTIwcHJvcG9zYWwlMjBmbG9vciUyMGN1c2hpb25zJTIwY2FuZGxlc3xlbnwwfHx8fDE3ODg0OTM1NzR8MA&ixlib=rb-4.1.0&q=85&w=1600&auto=format&fit=crop",
    proposal: "https://images.unsplash.com/photo-1687362575187-ee2bfa7a7d23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBwaWNuaWMlMjBzZXR1cCUyMHJvbWFudGljJTIwcHJvcG9zYWwlMjBmbG9vciUyMGN1c2hpb25zJTIwY2FuZGxlc3xlbnwwfHx8fDE3ODg0OTM1NzR8MA&ixlib=rb-4.1.0&q=85&w=1200&auto=format&fit=crop",
    bridal: "https://images.unsplash.com/photo-1725573839658-feedf0647b0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxvdXRkb29yJTIwYnJpZGFsJTIwc2hvd2VyJTIwcm9tYW50aWMlMjBwaWNuaWMlMjB0YWJsZSUyMGZsb3JhbCUyMGFycmFuZ2VtZW50fGVufDB8fHx8MTc4ODQ5MzU3NHww&ixlib=rb-4.1.0&q=85&w=1200&auto=format&fit=crop",
    dateNight: "https://images.unsplash.com/photo-1529516222410-a269d812f320?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxyb21hbnRpYyUyMGNhbmRsZWxpdCUyMG91dGRvb3IlMjBkaW5uZXIlMjBkYXRlJTIwbmlnaHQlMjBsdXh1cnklMjBzZXR1cHxlbnwwfHx8fDE3ODg0OTM1NzR8MA&ixlib=rb-4.1.0&q=85&w=1200&auto=format&fit=crop",
    birthday: "https://images.unsplash.com/photo-1657447512778-7d6f7a0d5b91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwaWNuaWMlMjBzZXR1cCUyMHJvbWFudGljJTIwcHJvcG9zYWwlMjBmbG9vciUyMGN1c2hpb25zJTIwY2FuZGxlc3xlbnwwfHx8fDE3ODg0OTM1NzR8MA&ixlib=rb-4.1.0&q=85&w=1200&auto=format&fit=crop",
    tablescape: "https://images.unsplash.com/photo-1657447512847-67f28a297ef9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBwaWNuaWMlMjBzZXR1cCUyMHJvbWFudGljJTIwcHJvcG9zYWwlMjBmbG9vciUyMGN1c2hpb25zJTIwY2FuZGxlc3xlbnwwfHx8fDE3ODg0OTM1NzR8MA&ixlib=rb-4.1.0&q=85&w=1200&auto=format&fit=crop",
    candlelight: "https://images.pexels.com/photos/39101731/pexels-photo-39101731.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const OCCASIONS = [
    {
        key: "proposals",
        label: "Proposals",
        title: "Luxury Proposal Setups in McKinney",
        blurb: "A candlelit low table, floor cushions, rose petals and a discreet planner behind the scenes — so all you have to do is ask.",
        image: "/media/proposal.jpg",
        alt: "Real Enchanting Escapes proposal setup with heart arch and Will You Marry Me sign by the fountain in McKinney",
    },
    {
        key: "showers",
        label: "Bridal Showers",
        title: "Bridal Shower Styling in DFW",
        blurb: "Blush linens, refined florals and layered rugs for the bride-to-be and her favorite people.",
        image: "/media/adriatica.jpg",
        alt: "Real bridal shower tablescape by Enchanting Escapes at Adriatica Village in McKinney at dusk",
    },
    {
        key: "birthdays",
        label: "Birthdays",
        title: "Birthday Picnic Setups in McKinney, TX",
        blurb: "Milestone birthdays styled to perfection — low tables, plush seating and a tablescape made for photos.",
        image: "/media/movie-night.jpg",
        alt: "Real outdoor movie night birthday celebration styled by Enchanting Escapes",
    },
    {
        key: "date-nights",
        label: "Date Nights",
        title: "Outdoor Date Nights in Dallas",
        blurb: "Just-because romance — an intimate candlelit escape under the Texas sky.",
        image: "/media/sunset-table.jpg",
        alt: "Real golden-hour lakeside date night tablescape by Enchanting Escapes in Dallas",
    },
    {
        key: "anniversaries",
        label: "Anniversaries",
        title: "Anniversary Picnics in Dallas-Fort Worth",
        blurb: "A heart of roses, candlelight and your story — anniversary picnics styled across Dallas-Fort Worth.",
        image: "/media/anniversary.jpg",
        alt: "Real anniversary picnic in Dallas-Fort Worth with red rose heart arch by Enchanting Escapes",
    },
];
